export default __webpack_public_path__ + "media/track-action3x.34f9fe88.png";